<template>
  <div class="form-preview flex-col gap-4">
    <div class="form-preview__header flex-col">
      <FormHeaderPreview v-if="form" :populated-data="form" />
    </div>
    <div v-if="sections" class="form-preview__sections flex-col">
      <SectionPreview
        v-for="section in sections"
        :key="section.id"
        :section="section"
      />
      <FormFooterPreview :populated-data="form" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { OlympusClient } from '@/OlympusClient'

import FormFooterPreview from '../../../builder/components/preview/footer/preview/FormFooterPreview.vue'
import FormHeaderPreview from '../../../builder/components/preview/heading/preview/FormHeaderPreview.vue'

import SectionPreview from './SectionPreview.vue'

export default {
  name: 'FormPreview',
  components: {
    FormFooterPreview,
    FormHeaderPreview,
    SectionPreview,
  },
  props: {
    /** Section */
    id: { type: String, required: true },
  },
  data() {
    return {
      form: null,
      loadingForm: false,
    }
  },
  computed: {
    ...mapGetters({
      blockById: 'websiteBuilder/blockById',
    }),
    formId() {
      const { id } = this

      return this.blockById(id)?.params?.formId
    },
    sections() {
      const { form } = this

      return form ? form.sections : null
    },
  },
  watch: {
    formId() {
      this.loadForm()
    },
  },
  created() {
    this.loadForm()
  },
  methods: {
    async loadForm() {
      const { form, formId, loadingForm } = this

      if (!loadingForm && formId && (!form || form.id !== formId)) {
        this.loadingForm = true
        this.form = await OlympusClient.forms.v1.forms.form.getPopulatedForm({
          params: { formId },
        })
        this.loadingForm = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@use '@/styles/breakpoints';

.form-preview {
  padding: 160px 120px;

  @include breakpoints.respond-to('md-and-up') {
    flex-direction: row;

    &__header {
      width: 50%;
    }
    &__sections {
      width: 50%;
    }
  }
}
</style>
